/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { Color } from "igniteui-react-core";
import { truncate } from "igniteui-react-core";
/**
 * @hidden
 */
var PlaceholderView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(PlaceholderView, _super);
    function PlaceholderView(a) {
        var _this = _super.call(this) || this;
        _this.f = null;
        _this.k = new Color();
        _this.h = 1;
        _this.a = true;
        _this.c = 0;
        _this.b = 0;
        _this.g = null;
        _this.f = a;
        _this.g = _this.f.createElement("div");
        _this.g.setRawStyleProperty("position", "absolute");
        _this.g.setRawStyleProperty("pointer-events", "none");
        return _this;
    }
    Object.defineProperty(PlaceholderView.prototype, "l", {
        get: function () {
            return this.k;
        },
        set: function (a) {
            this.k = a;
            this.j();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlaceholderView.prototype, "i", {
        get: function () {
            return this.h;
        },
        set: function (a) {
            this.a = true;
            this.h = a;
            this.j();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlaceholderView.prototype, "e", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            this.c = a;
            this.j();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlaceholderView.prototype, "d", {
        get: function () {
            return this.b;
        },
        set: function (a) {
            this.b = a;
            this.j();
        },
        enumerable: true,
        configurable: true
    });
    PlaceholderView.prototype.j = function () {
        var a = this.e;
        var b = this.d;
        var c = Color.u(truncate((this.k.l * this.h)), this.k.o, this.k.n, this.k.m);
        this.g.setRawStyleProperty("background-color", c.colorString);
        this.g.setRawStyleProperty("width", a + "px");
        this.g.setRawStyleProperty("height", b + "px");
    };
    PlaceholderView.$t = markType(PlaceholderView, 'PlaceholderView');
    return PlaceholderView;
}(Base));
export { PlaceholderView };
//# sourceMappingURL=PlaceholderView.js.map
